export default __webpack_public_path__ + "static/media/arrow_left.6799ea87.svg";